import get from "lodash/get";
import { getLatestUserCookie } from "../components/Login/user_session";
import { fetchData } from "./fetchData";
export const saveVenuesApi = (sitecoreContext, ids) => {
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  return getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
    if (userCookie.login_status && !userCookie.error) {
      return fetchData({
        path: `${apiGlobal}/graphql/user`,
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: `mutation addVenues {
                            addVenues(venueIds:[${ids.map(id => `"${id}"`).join(', ')}]) {
                                venueId,
                                created
                            }
                        }`
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};
export const deleteVenuesApi = (sitecoreContext, ids) => {
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  return getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
    if (userCookie.login_status && !userCookie.error) {
      return fetchData({
        path: `${apiGlobal}/graphql/user`,
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: `mutation deleteVenues {
                            deleteVenues(venueIds:[${ids.map(id => `"${id}"`).join(', ')}]) {
                                venueId,
                                created
                            }
                        }`
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};
export const getVenuesApi = sitecoreContext => {
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  return getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
    if (userCookie.login_status && !userCookie.error) {
      return fetchData({
        path: `${apiGlobal}/graphql/user`,
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: `{ user {
                            venues {
                                venueId,
                                created
                            }
                        }}`
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};